package com.essntl.uikit.components.pdfviewer

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

@Composable
actual fun PdfViewer(state: PdfViewerState, modifier: Modifier) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .padding(20.dp)
    ) {
        Text(
            text = "Pdf viewer is not supported on mobile yet.",
        )
    }
}